import { Formik, Form, Field, ErrorMessage } from "formik";
import { Button, Modal, Space } from "antd";
import * as Yup from "yup";

// --------------- component
import { InputField, SelectField } from "../../../components";

// --------------- style
import "./style.css";
import { api } from "../../../api/url";
import axios from "axios";
import { toast } from "react-hot-toast";
const genders = [
  { name: "آقا", id: 1 },
  { name: "خانم", id: 2 },
];

const ProfileSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("فیلد نام الزامی می‌باشد")
    .matches(/^\s*\S[\s\S]*$/, "فیلد نمی‌تواند خالی باشد"),
  lastName: Yup.string()
    .required("فیلد نام‌خانوادگی الزامی می‌باشد")
    .matches(/^(?!\s+$)/, "فیلد نمی‌تواند خالی باشد"),
  genderId: Yup.string().required("فیلد جنسیت الزامی می‌باشد"),
  nationalCode: Yup.string()
    .required("فیلد کدملی الزامی می‌باشد")
    .matches(/^(?!\s+$)/, "فیلد نمی‌تواند خالی باشد")
    .matches(/^\d+$/, "فرمت کدملی صحیح نمی‌باشد"),
});

const GetPhoneNumber = (props) => {
  const handleOk = () => {
    props.setOpen(false);
  };
  const handleCancel = () => {
    props.setOpen(false);
  };

  // ------------------- update user info
  const UpdateUser = async (value, setSubmitting) => {
    await axios({
      method: "put",
      url: api + "appointment/user/update",
      data: {
        userId: localStorage.getItem("user"),
        firstName: value.firstName,
        lastName: value.lastName,
        genderId: value.genderId,
        nationalCode: value.nationalCode,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        setSubmitting(false);
        if (res.data.successfull === false)
          res.data.validationErrors.map((item) => toast.error(item));
        else {
          toast.success("ویرایش اطلاعات با موفقیت انجام شد!");
          handleCancel();
        }
      })
      .catch((err) => {
        toast.error("خطا در ویرایش اطلاعات");

        setSubmitting(false);
      });
  };

  return (
    <Modal
      open={props.open}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      style={{
        top: 50,
      }}
    >
      <div className="modal-phonenumber-container">
        <Formik
          initialValues={{
            firstName: props.user.firstName,
            lastName: props.user.lastName,
            nationalCode: props.user.nationalCode,
            genderId: props.user.genderId,
            mobileNo: props.user.mobileNo,
          }}
          validationSchema={ProfileSchema}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            UpdateUser(values, setSubmitting);
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <h5 className="visit-userinfo-modal-title">تکمیل اطلاعات شخصی</h5>
              <p className="visit-userinfo-modal-description">
                برای ثبت نوبت ابتدا باید اطلاعات خودرا وارد کنید.
              </p>
              <div className="profile-field-section visit-userinfo-field">
                <InputField name="firstName" title="نام" />
                <InputField name="lastName" title="نام‌خانوادگی" />
              </div>

              <div className="profile-field-section visit-userinfo-field">
                <SelectField
                  selectStyle={{ width: "100%" }}
                  options={genders}
                  name="genderId"
                  title="جنسیت"
                />
              </div>

              <div className="profile-field-section visit-userinfo-field">
                <InputField inputstyle={{ textAlign: 'right' }} type='tel' maxlength="10" name="nationalCode" title="کدملی" />
                <InputField disabled name="mobileNo" title="شماره تماس" />
              </div>

              <button
                className="submit-form-btn visit-userinfo-btn"
                type="submit"
                disabled={isSubmitting}
              >
                تایید
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default GetPhoneNumber;
